import { DashboardTask } from './queries';

export const parseJsonField = <T>(
  value: T | string | null | undefined
): T | null => {
  if (value == null || value === '') return null;
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};

export const parseDashboardTaskJson = (task: DashboardTask): DashboardTask => ({
  ...task,
  selectorInfo: parseJsonField(task.selectorInfo) || {},
  browserInfo: parseJsonField(task.browserInfo) || {},
  data: parseJsonField(task.data)
});
